import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import agLogo from "../images/favicon.webp"
import './typography.css'

const NAV_LINKS = [
  { label: "Books", id: "books" },
  { label: "SPP", id: "spp" },
  { label: "Research", id: "research" },
  { label: "Podcast", id: "podcast" },
  { label: "Media", id: "media" },
  { label: "Data", id: "data" },
  { label: "Contact", id: "contact" },
]

const Header = ({ rootPage }) => {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40)
    window.addEventListener("scroll", handler)
    return () => window.removeEventListener("scroll", handler)
  }, [])

  const scrollTo = (id) => {
    setMenuOpen(false)
    if (rootPage) {
      const el = document.getElementById(id)
      if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" })
    }
  }

  return (
    <nav style={{ ...navStyle, boxShadow: scrolled ? "0 2px 20px rgba(28,54,116,0.08)" : "none" }}>
      <div style={navInner} className="nav-inner">
        <Link to="/" style={logoLinkStyle} aria-label="Agustina Giraudy — home">
          <img src={agLogo} alt="Agustina Giraudy" style={logoImgStyle} />
        </Link>

        <div style={linksStyle} className="nav-desktop-links">
          {NAV_LINKS.map(({ label, id }) => (
            rootPage
              ? <button key={id} onClick={() => scrollTo(id)} style={linkStyle}>{label}</button>
              : <Link key={id} to={`/#${id}`} style={linkStyle}>{label}</Link>
          ))}
          <a href="/files/cv.pdf?v=2" target="_blank" rel="noreferrer" style={cvStyle}>CV</a>
        </div>

        <button
          onClick={() => setMenuOpen(o => !o)}
          style={hamburgerStyle}
          className="nav-hamburger"
          aria-label="Toggle menu"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {menuOpen && (
        <div style={mobileMenuStyle}>
          {NAV_LINKS.map(({ label, id }) => (
            <button key={id} onClick={() => scrollTo(id)} style={mobileLinkStyle}>{label}</button>
          ))}
          <a href="/files/cv.pdf?v=2" target="_blank" rel="noreferrer" style={mobileCvStyle}>CV</a>
        </div>
      )}
    </nav>
  )
}

const navStyle = {
  position: "fixed",
  top: 0, left: 0, right: 0,
  zIndex: 100,
  background: "var(--cream)",
  borderBottom: "1px solid var(--cream-mid)",
  transition: "box-shadow 0.3s",
}

const navInner = {
  maxWidth: "1320px",
  margin: "0 auto",
  padding: "0 40px",
  height: "58px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}

const logoLinkStyle = {
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "none",
  lineHeight: 0,
}

const logoImgStyle = {
  height: "36px",
  width: "auto",
  display: "block",
  marginBottom: 0,
}

const linksStyle = {
  display: "flex",
  gap: "32px",
  alignItems: "center",
}

const linkStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 400,
  fontSize: "11px",
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--ink-mid)",
  textDecoration: "none",
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
}

const cvStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 400,
  fontSize: "11px",
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--cobalt)",
  border: "1px solid var(--cobalt)",
  padding: "6px 16px",
  textDecoration: "none",
}

const hamburgerStyle = {
  display: "none",
  background: "none",
  border: "none",
  fontSize: "22px",
  cursor: "pointer",
  color: "var(--cobalt)",
  padding: "11px 12px",
  minWidth: "44px",
  minHeight: "44px",
  lineHeight: 1,
}

const mobileMenuStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "12px 24px 20px",
  borderTop: "1px solid var(--cream-mid)",
  gap: "12px",
}

const mobileLinkStyle = {
  ...linkStyle,
  fontSize: "13px",
  padding: "12px 0",
  textAlign: "left",
  width: "100%",
}

const mobileCvStyle = {
  ...cvStyle,
  display: "inline-block",
  marginTop: "4px",
  width: "fit-content",
  padding: "13px 20px",
}

export default Header
